(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["nuvora-compact-reviews"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('nuvora-compact-reviews')) {
  customElements.define('nuvora-compact-reviews', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      this.slides = [...this.querySelectorAll('.ncr__slide')];
      this.index = 0;
      this.querySelector('.ncr__controls').hidden = this.slides.length < 2;
      this.querySelectorAll('[data-direction]').forEach(button => button.addEventListener('click', () => {
        this.index = (this.index + Number(button.dataset.direction) + this.slides.length) % this.slides.length;
        this.show();
      }));
      this.dataset.ready = 'true';
      this.show();
    }
    show() {
      this.slides.forEach((slide, index) => { slide.hidden = index !== this.index; });
      this.querySelector('.ncr__count').textContent = (this.index + 1) + '/' + this.slides.length;
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
